<template>
  <ul class="count-down-component">
    <li class="item" v-text="autoAddZero(date.hour)" :style="itemStyle" />
    <li class="colon">:<li>
    <li class="item" v-text="autoAddZero(date.minute)" :style="itemStyle" />
    <li class="colon">:<li>
    <li class="item" v-text="autoAddZero(date.second)" :style="itemStyle" />
  </ul>
</template>

<script>
export default {
  props: {
    timeStamp: {
      type: Number,
      default: () => 0
    },
    onCDend: {
      type: Function
    },
    itemStyle: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      cdTime: this.timeStamp
    }
  },
  computed: {
    date() {
      return this.getTime(this.cdTime)
    }
  },
  watch: {
    timeStamp() {
      // 倒计时总数发生变化时，从新计算
      this.unBindCD()
      this.bindCD()
    }
  },
  mounted() {
    this.bindCD()
  },
  beforeDestroy() {
    this.unBindCD()
  },
  methods: {
    getTime(time) {
      if (time < 1000) {
        return {
          day: 0,
          hour: 0,
          minute: 0,
          second: 0
        }
      }
      const everySecond = 1000
      const everyMinute = 60 * everySecond
      const everyHour = 60 * everyMinute
      const everyDay = 24 * everyHour
      const day = parseInt(time / everyDay, 10)
      const hour = parseInt((time - day * everyDay) / everyHour, 10)
      const minute = parseInt((time - day * everyDay - hour * everyHour) / everyMinute, 10)
      const second = parseInt((time - day * everyDay - hour * everyHour - minute * everyMinute) / everySecond, 10)
      return {
        day,
        hour,
        minute,
        second
      }
    },
    bindCD() {
      // 绑定cd时，拿到当前开始日期的时间戳，在程序进入后台时，setInterval执行将失准；
      this.startTime = Date.now()
      this.timer = setInterval(() => {
        const originTimeStamp = this.timeStamp
        // 倒计时以实际时间流逝量为准
        const currProgress = Math.floor((Date.now() - this.startTime) / 1000)
        let nextTime = originTimeStamp - currProgress * 1000

        this.cdTime = nextTime
        if (nextTime <= 0) {
          this.$emit('onCDend')
          this.unBindCD()
        }
      }, 1000)
    },
    unBindCD() {
      this.timer && clearInterval(this.timer)
    },
    autoAddZero(num) {
      if (num < 10) {
        return '0' + num
      }
      return num
    }
  }
}
</script>

<style lang="scss" scoped>
  .count-down-component {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;

    li.item {
      width: 1.55rem;
      line-height: 1.3rem;
      border-radius: 2px;
      padding: 0;
      font-size: 16px;
      text-align: center;
      background-color: #dd5236;
      color: #fff;
    }
    li.colon {
      font-size: 14px;
      color: #dd5236;
      font-weight: bold;
    }
  }
</style>
